import React, { ReactNode } from 'react';

export const Restrito: React.FC<{children: ReactNode, aberto: boolean | undefined, aviso?: ReactNode}> = (props) => {
    if (props.aberto) {
        return <>{props.children}</> 
    }

    if(props.aviso){
        return <>{props.aviso}</>
    }

    return <></>
}

export default Restrito;